import "./index.css"
import "../../assets/iconfont/iconfont.css"
import { Link } from "react-router-dom"

export const Header = () => {
  return <header>
    <div className="nav">
      <div><a href="#" className="iconfont icon-shouye"></a></div>
      <div><Link to="/">Home</Link></div>
      <div><Link to="/note">Note</Link></div>
      <div><Link to="/link">Link</Link></div>
      <div><Link to="/">default</Link></div>
      <div><Link to="/">default</Link></div>
    </div>
    <div className="search">
      <div className="center">
        <input type="search" placeholder="Please input keyword"></input>
        <div className="button"><Link to="/">Search</Link></div>
        <div className="iconfont icon-search"></div>
      </div>
    </div>
  </header>
}

export const Footer = () => {
  return (<footer>
    <div>本网站作者为“蔡大帅哥”</div>
    <div>本网站纯原创，纯手敲，无ai</div>
    <div><a href="https://beian.miit.gov.cn/" target="_blank">备案号：冀ICP备2026032731号</a></div>
    <div><a href=" " rel="noreferrer" target="_blank">冀公网安备13028302000281号</a ></div>
  </footer>)
}